import React, { useState } from 'react';
import './MapWithDescription.css';
import Asals from '../assets/asals.png';
import PdfViewer from '../About/PdfViewer';
import Loader from '../Loader/Loader'; // import the Loader component

const MapWithDescription = () => {
  const [showPdfViewer, setShowPdfViewer] = useState(false);
  const [loading, setLoading] = useState(false); // add state for loading indicator

  function handleReadMoreClick() {
    setLoading(true); // set loading state to true
    setTimeout(() => {
      setShowPdfViewer(true);
      setLoading(false); // set loading state to false when the PDF viewer is ready
    }, 5000);
  }

  return (
    <div className="image-description">
      <img src={Asals} alt='asals' className="image" />
      <div className="description">
        <h2>Map of ASAL Counties in Kenya</h2>
        {loading ? (
          <Loader /> // show the loading indicator
        ) : showPdfViewer ? (
          <PdfViewer onClose={() => setShowPdfViewer(false)} />
        ) : (
          <>
            <p>Arid and semi-arid regions are areas in Kenya that receive very low and unpredictable rainfall, leading to water scarcity, desertification, and other environmental challenges. These regions cover about 80%...</p>
            <button className="read-more-button" onClick={handleReadMoreClick}>Read More</button>
          </>
        )}
      </div>
    </div>
  );
};

export default MapWithDescription;
